import React from "react";
import {NOTISERVICE_URL} from "../../../redux/actions/dashboard/env.variables";
import "../../Notiservice/notiservice";

interface Props {
  auth: any;
  logout: any;
  redirectToAxumAccount: () => void,
}

export default ({auth, logout, redirectToAxumAccount }: Props) => {
  return (
    <nav className="navbar navbar-inverse navbar-fixed-top" role="navigation" id="header" style={{fontSize: "14px"}}>
      <div className="container-fluid">
          <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                  data-target="#collapsable-navbar">
                  <span className="sr-only">Menú</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
              </button>
              <a className="navbar-brand tenant-name">{ auth && auth.isLoggedIn? auth.user.organizationCode: '' }</a>
          </div>
          <div className="collapse navbar-collapse" id="collapsable-navbar">
            <ul className="nav navbar-nav navbar-right">
              <li>
                {/*@ts-ignore*/}
                <notiservice-web-ui notiservice-base-url={NOTISERVICE_URL}/>
              </li>
              <li>
                <a onClick={()=>{redirectToAxumAccount()}} title="Axum account" style={{cursor: "pointer"}}>
                  <span className="glyphicon glyphicon-th" aria-hidden="true"></span>
                </a>
              </li>
              <li>
                <label className="navbar-text">{ auth && auth.isLoggedIn? auth.user.name: '' }</label>
              </li>
              <li>
                <a onClick={()=>{logout()}} style={{cursor: "pointer"}}><span
                                className="glyphicon glyphicon-log-out"></span> <span
                                className="hidden-xs">Salir</span></a>
              </li>
            </ul>
          </div>
      </div>
    </nav>
  );
};
